var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.62012H4.66667C2.66667 1.62012 1.33333 2.95345 1.33333 4.95345V8.95345C1.33333 10.9534 2.66667 12.2868 4.66667 12.2868V13.7068C4.66667 14.2401 5.26 14.5601 5.7 14.2601L8.66667 12.2868H11.3333C13.3333 12.2868 14.6667 10.9534 14.6667 8.95345V4.95345C14.6667 2.95345 13.3333 1.62012 11.3333 1.62012ZM8 9.73345C7.72 9.73345 7.5 9.50678 7.5 9.23345C7.5 8.96012 7.72 8.73345 8 8.73345C8.28 8.73345 8.5 8.96012 8.5 9.23345C8.5 9.50678 8.28 9.73345 8 9.73345ZM8.84 6.96678C8.58 7.14012 8.5 7.25345 8.5 7.44012V7.58012C8.5 7.85345 8.27333 8.08012 8 8.08012C7.72667 8.08012 7.5 7.85345 7.5 7.58012V7.44012C7.5 6.66678 8.06667 6.28678 8.28 6.14012C8.52667 5.97345 8.60667 5.86012 8.60667 5.68678C8.60667 5.35345 8.33333 5.08012 8 5.08012C7.66667 5.08012 7.39333 5.35345 7.39333 5.68678C7.39333 5.96012 7.16667 6.18678 6.89333 6.18678C6.62 6.18678 6.39333 5.96012 6.39333 5.68678C6.39333 4.80012 7.11333 4.08012 8 4.08012C8.88667 4.08012 9.60667 4.80012 9.60667 5.68678C9.60667 6.44678 9.04667 6.82678 8.84 6.96678Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.1ce99ea514722051102baa6cfe80f3aa.svg";
export { ForwardRef as ReactComponent };